// Bridge between the Zita web app and the Zita Guided Scan extension.
// The extension declares `externally_connectable.matches` for these hosts,
// so `chrome.runtime.sendMessage(<extensionId>, {...})` succeeds from the
// page.
//
// The extension ID is provided at build time via REACT_APP_ZITA_EXT_ID (set
// after the extension is packaged/installed and its stable id is known). In
// dev / preview environments it is fine for this to be empty — the bridge
// silently no-ops so it never breaks the app.

const EXT_ID = process.env.REACT_APP_ZITA_EXT_ID || '';

function _canBridge() {
  return typeof window !== 'undefined'
    && typeof window.chrome !== 'undefined'
    && typeof window.chrome.runtime !== 'undefined'
    && typeof window.chrome.runtime.sendMessage === 'function';
}

async function _send(msg) {
  if (!EXT_ID || !_canBridge()) return { ok: false, reason: 'no_extension' };
  return new Promise((resolve) => {
    try {
      window.chrome.runtime.sendMessage(EXT_ID, msg, (res) => {
        if (window.chrome.runtime.lastError) {
          resolve({ ok: false, reason: 'ext_not_installed' });
        } else {
          resolve(res || { ok: false });
        }
      });
    } catch (e) {
      resolve({ ok: false, reason: 'exception', error: String(e) });
    }
  });
}

export async function pushSessionTokenToExtension(token) {
  return _send({ type: 'ZITA_SESSION_TOKEN', token, backend: window.location.origin });
}

export async function pushActiveScanToExtension(scan_id) {
  return _send({ type: 'ZITA_ACTIVE_SCAN', scan_id });
}

export async function clearActiveScanFromExtension() {
  return _send({ type: 'ZITA_CLEAR_ACTIVE_SCAN' });
}

export async function pingExtension() {
  return _send({ type: 'ZITA_PING' });
}
